const LUNAR_CDN = 'https://cdn.jsdelivr.net/gh/6tail/lunar-javascript@master/lunar.js';
const IZTRO_CDN = 'https://cdn.jsdelivr.net/npm/iztro@2.0.5/dist/iztro.min.js';

const heavenlyStems = {
  甲: '木',
  乙: '木',
  丙: '火',
  丁: '火',
  戊: '土',
  己: '土',
  庚: '金',
  辛: '金',
  壬: '水',
  癸: '水',
};

const earthlyBranches = {
  子: '水',
  丑: '土',
  寅: '木',
  卯: '木',
  辰: '土',
  巳: '火',
  午: '火',
  未: '土',
  申: '金',
  酉: '金',
  戌: '土',
  亥: '水',
};

const hiddenStems = {
  子: ['癸'],
  丑: ['己', '癸', '辛'],
  寅: ['甲', '丙', '戊'],
  卯: ['乙'],
  辰: ['乙', '癸', '戊'],
  巳: ['丙', '戊', '庚'],
  午: ['丁', '己'],
  未: ['己', '丁', '乙'],
  申: ['庚', '壬', '戊'],
  酉: ['辛'],
  戌: ['戊', '辛', '丁'],
  亥: ['壬', '甲'],
};

const starElements = {
  贪狼: { element: '木', score: 1 },
  天机: { element: '木', score: 1 },
  廉贞: { element: '木', score: 1 },
  化权: { element: '木', score: 1 },
  太阳: { element: '火', score: 1 },
  火星: { element: '火', score: 0.66 },
  铃星: { element: '火', score: 0.66 },
  天魁: { element: '火', score: 0.33 },
  天钺: { element: '火', score: 0.33 },
  地空: { element: '火', score: 0.33 },
  地劫: { element: '火', score: 0.33 },
  紫微: { element: '土', score: 2 },
  天府: { element: '土', score: 2 },
  天梁: { element: '土', score: 1 },
  禄存: { element: '土', score: 1 },
  化禄: { element: '土', score: 1 },
  左辅: { element: '土', score: 0.33 },
  武曲: { element: '金', score: 1 },
  七杀: { element: '金', score: 1 },
  文昌: { element: '金', score: 1 },
  擎羊: { element: '金', score: 0.75 },
  陀罗: { element: '金', score: 0.75 },
  巨门: { element: '水', score: 1 },
  破军: { element: '水', score: 1 },
  太阴: { element: '水', score: 1 },
  天同: { element: '水', score: 1 },
  天相: { element: '水', score: 1 },
  文曲: { element: '水', score: 1 },
  化科: { element: '水', score: 1 },
  化忌: { element: '水', score: 1 },
  右弼: { element: '水', score: 0.33 },
};

/** Display labels for English storefront: Pinyin + meaning */
const starDisplayEn = {
  紫微: 'Zi Wei Star (The Emperor Star)',
  天机: 'Tian Ji Star (The Wisdom Star)',
  太阳: 'Tai Yang Star (The Radiance Star)',
  武曲: 'Wu Qu Star (The Prosperity Star)',
  天同: 'Tian Tong Star (The Harmony Star)',
  廉贞: 'Lian Zhen Star (The Integrity Star)',
  天府: 'Tian Fu Star (The Stability Star)',
  太阴: 'Tai Yin Star (The Gentle Wealth Star)',
  贪狼: 'Tan Lang Star (The Desire Star)',
  巨门: 'Ju Men Star (The Communication Star)',
  天相: 'Tian Xiang Star (The Balance Star)',
  天梁: 'Tian Liang Star (The Guidance Star)',
  七杀: 'Qi Sha Star (The Warrior Star)',
  破军: 'Po Jun Star (The Breakthrough Star)',
  文昌: 'Wen Chang (The Scholar)',
  文曲: 'Wen Qu (The Artist)',
  左辅: 'Zuo Fu (Left Assistant)',
  右弼: 'You Bi (Right Assistant)',
  天魁: 'Tian Kui (Heavenly Leader)',
  天钺: 'Tian Yue (Heavenly Axe)',
  禄存: 'Lu Cun (Stored Wealth)',
  擎羊: 'Qing Yang (The Blade)',
  陀罗: 'Tuo Luo (The Obstructor)',
  火星: 'Huo Xing (The Fire Star)',
  铃星: 'Ling Xing (The Bell Star)',
  地空: 'Di Kong (Earthly Void)',
  地劫: 'Di Jie (Earthly Calamity)',
  化禄: 'Hua Lu (Transforming Wealth)',
  化权: 'Hua Quan (Transforming Authority)',
  化科: 'Hua Ke (Transforming Fame)',
  化忌: 'Hua Ji (Transforming Trouble)',
};

function isChineseLocale(locale) {
  return String(locale || '').toLowerCase().startsWith('zh');
}

/**
 * Keep Chinese names for scoring; translate only for display.
 * @param {string} name
 * @param {string} [locale]
 */
function formatStarForDisplay(name, locale) {
  if (isChineseLocale(locale)) return name;
  return starDisplayEn[name] || name;
}

const controlMap = { 金: '木', 木: '土', 土: '水', 水: '火', 火: '金' };

const elementLabels = {
  木: 'Wood',
  火: 'Fire',
  土: 'Earth',
  金: 'Metal',
  水: 'Water',
};

const elementSlugs = {
  木: 'wood',
  火: 'fire',
  土: 'earth',
  金: 'metal',
  水: 'water',
};

  const elementColors = {
  木: [{ name: 'Wood', hex: '#5f8f4e' }],
  火: [{ name: 'Fire', hex: '#c94b3a' }],
  土: [{ name: 'Earth', hex: '#9a7a32' }],
  金: [{ name: 'Metal', hex: '#e0b84d' }],
  水: [{ name: 'Water', hex: '#3f7ea8' }],
};

const crystals = {
  木: ['Green Phantom Quartz', 'Dongling Jade'],
  火: ['Garnet', 'Red Agate'],
  土: ['Citrine', 'Tiger Eye'],
  金: ['Clear Quartz', 'Moonstone'],
  水: ['Obsidian', 'Aquamarine'],
};

const GENDER_MAP = { male: '男', female: '女' };

/** @type {Promise<void> | null} */
let enginesPromise = null;

/**
 * @param {string} src
 * @returns {Promise<void>}
 */
function loadScript(src) {
  const existing = document.querySelector(`script[data-fea-src="${src}"]`);
  if (existing) {
    return existing.dataset.loaded === 'true'
      ? Promise.resolve()
      : new Promise((resolve, reject) => {
          existing.addEventListener('load', () => resolve(), { once: true });
          existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
        });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.dataset.feaSrc = src;
    script.onload = () => {
      script.dataset.loaded = 'true';
      resolve();
    };
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}

function ensureEngines() {
  if (!enginesPromise) {
    enginesPromise = (async () => {
      await loadScript(LUNAR_CDN);
      await loadScript(IZTRO_CDN);
      if (typeof window.Solar === 'undefined') {
        throw new Error('Bazi engine failed to load. Please check your network.');
      }
    })();
  }
  return enginesPromise;
}

function initElements() {
  return { 木: 0, 火: 0, 土: 0, 金: 0, 水: 0 };
}

function getSeasonElement(month) {
  if ([1, 2, 3].includes(month)) return '木';
  if ([4, 5, 6].includes(month)) return '火';
  if ([7, 8, 9].includes(month)) return '金';
  if ([10, 11, 12].includes(month)) return '水';
  return '土';
}

function calculateBaziElements(bazi) {
  const elements = initElements();
  bazi.forEach((item) => {
    if (heavenlyStems[item.stem]) elements[heavenlyStems[item.stem]] += 1;
    if (earthlyBranches[item.branch]) elements[earthlyBranches[item.branch]] += 1;
    if (hiddenStems[item.branch]) {
      hiddenStems[item.branch].forEach((hidden) => {
        elements[heavenlyStems[hidden]] += 0.5;
      });
    }
  });
  return elements;
}

function calculateZiweiElements(stars) {
  const result = initElements();
  stars.forEach((star) => {
    if (starElements[star]) {
      result[starElements[star].element] += starElements[star].score;
    }
  });
  return result;
}

function mergeElements(a, b) {
  const result = initElements();
  Object.keys(result).forEach((key) => {
    result[key] = (a[key] || 0) + (b[key] || 0);
  });
  return result;
}

function getStrongestElement(elements) {
  return Object.keys(elements).reduce((a, b) => (elements[a] > elements[b] ? a : b));
}

function getWeakestElement(elements) {
  return Object.keys(elements).reduce((a, b) => (elements[a] < elements[b] ? a : b));
}

function calculateUsefulGod(elements, month) {
  const strongest = getStrongestElement(elements);
  const weakest = getWeakestElement(elements);
  const season = getSeasonElement(month);
  let usefulGod = controlMap[strongest];

  if (season === '水' && elements['火'] < 2) usefulGod = '火';
  if (season === '火' && elements['水'] < 2) usefulGod = '水';

  return { usefulGod, unfavorableGod: strongest, weakest };
}

function generateRecommendations(usefulGod) {
  return {
    colors: elementColors[usefulGod] || [],
    crystals: crystals[usefulGod] || [],
  };
}

/**
 * iztro timeIndex: 0 early Rat … 12 late Rat
 * @param {number} hour
 */
function getZiweiTimeIndex(hour) {
  if (!Number.isInteger(hour) || hour < 0 || hour > 23) {
    throw new Error('Invalid time of birth.');
  }
  if (hour === 0) return 0;
  if (hour === 23) return 12;
  return Math.floor((hour + 1) / 2);
}

function calculateDestinySystem(data) {
  const baziElements = calculateBaziElements(data.bazi);
  const ziweiElements = calculateZiweiElements(data.ziweiStars);
  const totalElements = mergeElements(baziElements, ziweiElements);
  const result = calculateUsefulGod(totalElements, data.month);
  const recommendation = generateRecommendations(result.usefulGod);

  return {
    fiveElements: totalElements,
    usefulGod: result.usefulGod,
    unfavorableGod: result.unfavorableGod,
    weakestElement: result.weakest,
    recommendedColors: recommendation.colors,
    recommendedCrystals: recommendation.crystals,
  };
}

function labelElement(key) {
  return elementLabels[key] || key;
}

/**
 * @param {{ dateVal: string, timeVal: string, genderVal: string, locale?: string }} input
 */
function runAssessment(input) {
  const { dateVal, timeVal, genderVal, locale = 'en' } = input;
  const Solar = window.Solar;
  const iztro = window.iztro;
  const chinese = isChineseLocale(locale);

  const [year, month, day] = dateVal.split('-');
  const [hour, minute] = timeVal.split(':');

  const solar = Solar.fromYmdHms(
    Number(year),
    Number(month),
    Number(day),
    Number(hour),
    Number(minute),
    0
  );
  const lunar = solar.getLunar();
  const baziObj = lunar.getEightChar();

  const baziArray = [
    { stem: baziObj.getYearGan(), branch: baziObj.getYearZhi() },
    { stem: baziObj.getMonthGan(), branch: baziObj.getMonthZhi() },
    { stem: baziObj.getDayGan(), branch: baziObj.getDayZhi() },
    { stem: baziObj.getTimeGan(), branch: baziObj.getTimeZhi() },
  ];

  const baziString = baziArray.map((item) => `${item.stem}${item.branch}`).join(' ');

  /** @type {string[]} */
  let ziweiStars = [];
  let ziweiMessage = '';

  try {
    if (!iztro?.astro || typeof iztro.astro.bySolar !== 'function') {
      throw new Error(chinese ? '紫微引擎不可用。' : 'Zi Wei engine is unavailable.');
    }

    const genderZh = GENDER_MAP[genderVal] || '男';
    const timeIndex = getZiweiTimeIndex(Number(hour));
    // Always use zh-CN so star names match starElements scoring keys.
    const ast = iztro.astro.bySolar(dateVal, timeIndex, genderZh, true, 'zh-CN');
    const destinyPalace = ast.palaces.find((p) => p.name === '命宫');

    if (!destinyPalace) {
      throw new Error(chinese ? '未找到命宫。' : 'Destiny palace not found.');
    }

    ziweiStars = (destinyPalace.majorStars || []).map((s) => s.name);
    ziweiMessage =
      ziweiStars.length > 0
        ? ziweiStars.map((name) => formatStarForDisplay(name, locale)).join(', ')
        : chinese
          ? '命宫无十四主星（空宫）'
          : 'Empty palace (no major stars)';
  } catch (error) {
    const detail = error instanceof Error ? error.message : String(error);
    ziweiMessage = chinese ? `紫微计算失败：${detail}` : `Zi Wei unavailable: ${detail}`;
    console.error('Zi Wei calculation unavailable');
  }

  const finalResult = calculateDestinySystem({
    month: Number(month),
    bazi: baziArray,
    ziweiStars,
  });

  return {
    bazi: baziString,
    ziwei: ziweiMessage,
    scores: finalResult.fiveElements,
    usefulKey: finalResult.usefulGod,
    useful: labelElement(finalResult.usefulGod),
    weakestKey: finalResult.weakestElement,
    weakest: labelElement(finalResult.weakestElement),
    unfavorableKey: finalResult.unfavorableGod,
    unfavorable: labelElement(finalResult.unfavorableGod),
    colors: finalResult.recommendedColors,
    crystals: finalResult.recommendedCrystals,
  };
}

/**
 * Recommend products whose tags match the balancing element (weakest, case-insensitive).
 * @param {unknown[]} catalog
 * @param {string} elementLabel
 * @param {string} elementKey
 */
function filterProductsByBalancingElement(catalog, elementLabel, elementKey) {
  const needles = new Set(
    [elementLabel, elementKey, elementSlugs[elementKey]]
      .filter(Boolean)
      .map((value) => String(value).toLowerCase())
  );

  return catalog
    .filter((product) => {
      if (!product || typeof product !== 'object') return false;
      const tags = Array.isArray(product.tags) ? product.tags : [];
      return tags.some((tag) => needles.has(String(tag).toLowerCase()));
    })
    .slice(0, 3);
}

/** Page-specific color rules; other assessment instances retain tag matching. */
function filterProductsByColorElement(catalog, elementKey) {
  const element = ({ '金': 'Metal', '水': 'Water', '土': 'Earth', '木': 'Wood', '火': 'Fire',
    Metal: 'Metal', Water: 'Water', Earth: 'Earth', Wood: 'Wood', Fire: 'Fire' })[elementKey];
  if (!element || !Array.isArray(catalog)) return [];
  const seen = new Set();
  return catalog.filter((product) => {
    if (!product || typeof product !== 'object' || product.eligible !== true) return false;
    const id = String(product.id || '');
    if (!/^\d+$/.test(id) || seen.has(id)) return false;
    if (!Array.isArray(product.balanceElements) || !product.balanceElements.includes(element)) return false;
    if (typeof product.url !== 'string' || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/\s?#]+(?:\?[^\s#]*)?$/.test(product.url)) return false;
    if (!product.title || !product.price || !product.image) return false;
    seen.add(id);
    return true;
  }).slice(0, 3);
}

class FiveElementsAnalysis extends HTMLElement {
  /** @type {AbortController | null} */
  #controller = null;

  /** @type {ReturnType<typeof runAssessment> | null} */
  #lastResult = null;

  // Invalidates a pending calculation when the visitor resets or leaves.
  #assessmentId = 0;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#mountEnergyRecommendations(signal);

    const form = this.querySelector('[data-fea-form]');
    const reset = this.querySelector('[data-fea-reset]');
    const unlockForm = this.querySelector('[data-fea-unlock-form]');
    const unlockSubmit = this.querySelector('[data-fea-unlock-submit]');

    form?.addEventListener('submit', this.#onSubmit, { signal });
    reset?.addEventListener('click', this.#onReset, { signal });
    // Capture phase + button click: never let the unlock form do a native navigation.
    unlockForm?.addEventListener('submit', this.#onUnlockSubmit, { capture: true, signal });
    unlockSubmit?.addEventListener('click', this.#onUnlockClick, { signal });

    const recipient = unlockForm instanceof HTMLFormElement ? String(unlockForm.dataset.feaReportMailto || '').trim() : '';
    const reportAvailable = recipient === 'contact.sanctura@gmail.com';
    this.querySelectorAll('[data-fea-unlock-email], [data-fea-unlock-submit], [data-fea-report-consent]').forEach((input) => {
      if (input instanceof HTMLInputElement || input instanceof HTMLButtonElement) input.disabled = !reportAvailable;
    });
    const submit = this.querySelector('[data-fea-submit]');
    if (submit instanceof HTMLButtonElement) submit.disabled = false;
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
    this.#clearPrivateState();
    this.#setView('intro');
    this.#setLoading(false);
    const submit = this.querySelector('[data-fea-submit]');
    if (submit instanceof HTMLButtonElement) submit.disabled = true;
  }

  #setError(message) {
    const errorEl = this.querySelector('[data-fea-error]');
    if (!(errorEl instanceof HTMLElement)) return;
    if (!message) {
      errorEl.hidden = true;
      errorEl.textContent = '';
      return;
    }
    errorEl.hidden = false;
    errorEl.textContent = message;
  }

  #setLoading(isLoading) {
    this.dataset.loading = isLoading ? 'true' : 'false';
    const button = this.querySelector('[data-fea-submit]');
    const label = this.querySelector('[data-fea-submit-label]');
    const loading = this.querySelector('[data-fea-submit-loading]');
    if (button instanceof HTMLButtonElement) button.disabled = isLoading;
    if (label instanceof HTMLElement) label.hidden = isLoading;
    if (loading instanceof HTMLElement) loading.hidden = !isLoading;
  }

  #renderBars(result) {
    const scores = result.scores;
    const max = Math.max(...Object.values(scores), 1);

    Object.entries(scores).forEach(([key, value]) => {
      const row = this.querySelector(`[data-fea-bar="${elementSlugs[key]}"]`);
      if (!(row instanceof HTMLElement)) return;

      const fill = row.querySelector('[data-fea-bar-fill]');
      const valueEl = row.querySelector('[data-fea-bar-value]');

      if (fill instanceof HTMLElement) {
        fill.style.width = `${Math.max((value / max) * 100, 4)}%`;
      }
      if (valueEl instanceof HTMLElement) {
        valueEl.textContent = value.toFixed(1);
      }
      if (key === result.weakestKey) {
        row.dataset.feaHighlight = 'useful';
      } else {
        delete row.dataset.feaHighlight;
      }
    });
  }

  #renderColors(colors) {
    const list = this.querySelector('[data-fea-colors]');
    if (!(list instanceof HTMLElement)) return;

    list.replaceChildren(
      ...colors.map(({ name, hex }) => {
        const item = document.createElement('li');
        item.className = 'fea__swatch';

        const dot = document.createElement('span');
        dot.className = 'fea__swatch-dot';
        dot.style.background = hex;

        const label = document.createElement('span');
        label.textContent = name;

        item.append(dot, label);
        return item;
      })
    );
  }

  #renderCrystals(crystals) {
    const list = this.querySelector('[data-fea-crystals]');
    if (!(list instanceof HTMLElement)) return;

    list.replaceChildren(
      ...crystals.map((name) => {
        const item = document.createElement('li');
        item.className = 'fea__stone';
        item.textContent = name;
        return item;
      })
    );
  }

  /**
   * Recommend up to 3 products whose tags match Your guiding element
   * (Balancing Element / weakest, case-insensitive).
   * @param {ReturnType<typeof runAssessment>} result
   */
  #renderProducts(result) {
    const grid = this.querySelector('[data-fea-product-grid]');
    const indexEl = this.querySelector('[data-fea-product-index]');

    if (!(grid instanceof HTMLElement)) return;

    grid.hidden = true;
    grid.replaceChildren();

    let catalog = [];
    try {
      catalog = JSON.parse(indexEl?.textContent || '[]');
      if (!Array.isArray(catalog)) catalog = [];
    } catch (error) {
      console.error(error);
      catalog = [];
    }

    const colorRecommendations = this.classList.contains('fea--reference');
    const products = colorRecommendations
      ? filterProductsByColorElement(catalog, result.weakestKey)
      : filterProductsByBalancingElement(catalog, result.weakest, result.weakestKey);

    if (products.length === 0) return;

    if (this.#energyRecommendationsEnabled()) {
      this.#restoreEnergyPreview();
      grid.replaceChildren(...products.map((product) => this.#createEnergyRecommendation(product)));
      this.#readEnergySaved();
      this.#paintEnergySaved();
      grid.hidden = false;
      return;
    }

    grid.replaceChildren(
      ...products.map((product, index) => {
        const link = document.createElement('a');
        link.className = colorRecommendations
          ? 'fea__product-card ser-necklace-card'
          : 'fea__product-card';
        link.href = product.url || '#';

        const media = document.createElement('span');
        media.className = 'fea__product-card-media';

        if (product.image) {
          const showMiddleDetail = colorRecommendations && index === 1
            && typeof product.detailImage === 'string' && product.detailImage.trim() !== '';
          const img = document.createElement('img');
          img.src = showMiddleDetail ? product.detailImage : product.image;
          img.alt = product.title || '';
          img.loading = 'lazy';
          if (colorRecommendations) {
            const picture = document.createElement('picture');
            picture.style.display = 'contents';
            picture.append(img);
            media.append(picture);
          } else {
            media.append(img);
          }
        }

        const title = document.createElement('p');
        title.className = 'fea__product-card-title';
        if (product.cardTextClass === 'sn-jewelry-card-text') title.classList.add('sn-jewelry-card-text');
        title.textContent = product.title || '';

        const price = document.createElement('p');
        price.className = 'fea__product-card-price';
        price.textContent = product.price || '';

        this.#appendNewProductBadge(media, product);
        link.append(media, title, price);
        return link;
      })
    );

    grid.hidden = false;
  }

  #energySaved = [];

  #energyPreview = null;

  #energyRecommendationsEnabled() {
    return this.classList.contains('fea--reference') && this.dataset.energyRecommendationActions === 'true';
  }

  #readEnergySaved() {
    try {
      const value = JSON.parse(localStorage.getItem('sanctura-saved-products') || '[]');
      if (Array.isArray(value)) this.#energySaved = value.filter((entry) => typeof entry === 'string');
    } catch (_) { /* Keep this page's saved state when browser storage is unavailable. */ }
  }

  #paintEnergySaved() {
    this.querySelectorAll('[data-energy-recommendation]').forEach((card) => {
      const button = card.querySelector('[data-energy-recommendation-wishlist]');
      if (!(button instanceof HTMLButtonElement)) return;
      const present = this.#energySaved.includes(card.dataset.productHandle);
      button.setAttribute('aria-pressed', String(present));
      button.setAttribute('aria-label', (present ? 'Remove ' : 'Save ') + card.dataset.productTitle + (present ? ' from wishlist on this browser' : ' to wishlist on this browser'));
      button.disabled = false;
    });
  }

  #restoreEnergyPreview() {
    const preview = this.#energyPreview;
    this.#energyPreview = null;
    if (!preview) return;
    preview.preload.onload = null;
    preview.preload.onerror = null;
    if (preview.applied && preview.img.getAttribute('src') === preview.detail) {
      preview.img.setAttribute('src', preview.full);
      preview.img.setAttribute('alt', preview.alt);
    }
  }

  #mountEnergyRecommendations(signal) {
    if (!this.#energyRecommendationsEnabled()) return;
    const grid = this.querySelector('[data-fea-product-grid]');
    if (!(grid instanceof HTMLElement)) return;
    this.#readEnergySaved();
    this.#paintEnergySaved();

    grid.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-energy-recommendation-wishlist]') : null;
      const card = button?.closest('[data-energy-recommendation]');
      if (!(button instanceof HTMLButtonElement) || !card || !grid.contains(card)) return;
      const handle = card.dataset.productHandle;
      if (!handle) return;
      event.preventDefault();
      event.stopPropagation();
      this.#readEnergySaved();
      const wasSaved = this.#energySaved.includes(handle);
      this.#energySaved = wasSaved ? this.#energySaved.filter((entry) => entry !== handle) : [...this.#energySaved, handle];
      let persistent = true;
      try { localStorage.setItem('sanctura-saved-products', JSON.stringify(this.#energySaved)); }
      catch (_) { persistent = false; }
      this.#paintEnergySaved();
      const status = card.querySelector('[data-energy-recommendation-status]');
      if (status) status.textContent = persistent ? (wasSaved ? 'Removed from your wishlist on this browser.' : 'Saved to your wishlist on this browser.') : (wasSaved ? 'Removed for this page only; browser storage is unavailable.' : 'Saved for this page only; browser storage is unavailable.');
    }, { signal });

    window.addEventListener('storage', (event) => {
      if (event.key === 'sanctura-saved-products' || event.key === null) {
        this.#readEnergySaved();
        this.#paintEnergySaved();
      }
    }, { signal });

    grid.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      const card = event.target instanceof Element ? event.target.closest('[data-energy-recommendation]') : null;
      if (!card || !grid.contains(card) || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
      this.#restoreEnergyPreview();
      const img = card.querySelector('img[data-energy-detail]');
      if (!(img instanceof HTMLImageElement)) return;
      const detail = img.dataset.energyDetail;
      const full = img.getAttribute('src');
      if (!detail || !full || detail === full) return;
      const preload = new Image();
      const preview = { card, img, preload, detail, full, alt: img.getAttribute('alt') || '', applied: false };
      this.#energyPreview = preview;
      preload.onload = () => {
        if (this.#energyPreview !== preview || !this.isConnected || !grid.contains(card) || !card.matches(':hover') || img.getAttribute('src') !== full) return;
        preview.applied = true;
        img.setAttribute('src', detail);
        img.setAttribute('alt', card.dataset.productTitle + ' — detail');
      };
      preload.onerror = () => { if (this.#energyPreview === preview) this.#restoreEnergyPreview(); };
      preload.src = detail;
    }, { signal });

    grid.addEventListener('pointerout', (event) => {
      const preview = this.#energyPreview;
      if (preview && event.target instanceof Node && preview.card.contains(event.target) && !(event.relatedTarget instanceof Node && preview.card.contains(event.relatedTarget))) this.#restoreEnergyPreview();
    }, { signal });
    grid.addEventListener('error', (event) => {
      if (this.#energyPreview?.img === event.target) this.#restoreEnergyPreview();
    }, { capture: true, signal });
    window.addEventListener('blur', () => this.#restoreEnergyPreview(), { signal });

    const observer = new MutationObserver(() => {
      if (this.#energyPreview && !grid.contains(this.#energyPreview.card)) this.#restoreEnergyPreview();
    });
    observer.observe(grid, { childList: true });
    signal.addEventListener('abort', () => { observer.disconnect(); this.#restoreEnergyPreview(); }, { once: true });
  }

  #appendNewProductBadge(media, product) {
    const ids = ['15260067004779', '15260066939243', '15260066840939'];
    const urls = ['/products/luodi-stud-earrings', '/products/halo-crystal-stud-earrings', '/products/square-link-stud-earrings'];
    const isNew = product.id != null ? ids.includes(String(product.id)) : urls.includes(product.url);
    if (!isNew) return;
    const badge = document.createElement('span');
    badge.className = 'sn-new-arrivals-badge';
    badge.textContent = 'New';
    badge.style.cssText = 'position:absolute;top:12px;left:12px;z-index:1;display:inline-block;background:transparent;color:#000;padding:5px 8px;font-family:var(--font-accent--family);font-size:11px;font-weight:700;line-height:1;letter-spacing:.08em;white-space:nowrap;pointer-events:none;';
    media.style.position = 'relative';
    media.append(badge);
  }

  #createEnergyRecommendation(product) {
    const card = document.createElement('article');
    card.className = 'fea__product-card ser-necklace-card';
    card.dataset.energyRecommendation = '';
    card.dataset.productId = String(product.id);
    card.dataset.productHandle = product.handle || '';
    card.dataset.productTitle = product.title || '';
    const link = document.createElement('a');
    link.className = 'fea__product-card-link';
    link.href = product.url;
    const media = document.createElement('span');
    media.className = 'fea__product-card-media';
    if (product.image) {
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title || '';
      img.loading = 'lazy';
      if (Number.isInteger(product.imageWidth) && product.imageWidth > 0) img.width = product.imageWidth;
      if (Number.isInteger(product.imageHeight) && product.imageHeight > 0) img.height = product.imageHeight;
      img.dataset.energyWhite = String(product.imageWhite === true);
      if (typeof product.detailImage === 'string' && product.detailImage.trim()) img.dataset.energyDetail = product.detailImage;
      media.append(img);
    }
    const title = document.createElement('p');
    title.className = 'fea__product-card-title';
    if (product.cardTextClass === 'sn-jewelry-card-text') title.classList.add('sn-jewelry-card-text');
    title.textContent = product.title || '';
    const price = document.createElement('p');
    price.className = 'fea__product-card-price';
    price.textContent = product.price || '';
    this.#appendNewProductBadge(media, product);
    link.append(media, title, price);
    card.append(link);
    const template = Array.from(this.querySelectorAll('template[data-energy-card-template]')).find((entry) => entry.dataset.productId === String(product.id) && entry.dataset.productHandle === product.handle && entry.dataset.productUrl === product.url);
    if (template instanceof HTMLTemplateElement) card.append(document.importNode(template.content, true));
    return card;
  }

  #setView(view) {
    this.dataset.view = view;

    if (view === 'results') {
      document.documentElement.dataset.feaView = 'results';
    } else {
      delete document.documentElement.dataset.feaView;
    }

    const intro = this.querySelector('[data-fea-view="intro"]');
    const results = this.querySelector('[data-fea-view="results"]');

    if (intro instanceof HTMLElement) intro.hidden = view === 'results';
    if (results instanceof HTMLElement) results.hidden = view !== 'results';
  }

  #showResults(result) {
    this.#setView('results');

    const results = this.querySelector('[data-fea-view="results"]');
    if (results instanceof HTMLElement) {
      results.dataset.accent = elementSlugs[result.weakestKey] || 'earth';
    }

    const map = {
      '[data-fea-bazi]': result.bazi,
      '[data-fea-ziwei]': result.ziwei,
      '[data-fea-weakest]': result.weakest,
      '[data-fea-unfavorable]': result.unfavorable,
      '[data-fea-useful]': result.weakest,
      '[data-fea-useful-glyph]': result.weakestKey,
    };

    Object.entries(map).forEach(([selector, value]) => {
      const el = this.querySelector(selector);
      if (el) el.textContent = value;
    });

    this.#renderBars(result);
    this.#renderColors(result.colors);
    this.#renderCrystals(result.crystals);
    this.#renderProducts(result);

    if (this.classList.contains('fea--reference')) {
      // Start the assessment result at the page top after the view has settled.
      requestAnimationFrame(() => {
        if (this.isConnected && this.dataset.view === 'results') {
          window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        }
      });
    } else {
      results?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  #clearInputs(selectors) {
    this.querySelectorAll(selectors).forEach((input) => {
      if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) return;
      if (input instanceof HTMLInputElement && (input.type === 'radio' || input.type === 'checkbox')) {
        input.checked = false;
        input.defaultChecked = false;
        input.removeAttribute('checked');
      } else {
        input.value = '';
        input.defaultValue = '';
        input.removeAttribute('value');
      }
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  #clearRawInputs() {
    this.#clearInputs('[name="full_name"], [name="date_of_birth"], [name="time_of_birth"], [name="place_of_birth"], [name="gender"]');
  }

  #clearPrivateState() {
    this.#assessmentId += 1;
    this.#lastResult = null;
    this.#clearRawInputs();
    this.#clearInputs('[data-fea-unlock-email], [data-fea-contact-email], [data-fea-contact-name], [data-fea-contact-body], [data-fea-subscribe-email], [data-fea-age-confirmation], [data-fea-report-consent], [data-fea-marketing-consent]');
    this.querySelectorAll('[data-fea-bazi], [data-fea-ziwei], [data-fea-weakest], [data-fea-unfavorable], [data-fea-useful], [data-fea-useful-glyph], [data-fea-bar-value]').forEach((el) => {
      el.textContent = '';
    });
    this.querySelectorAll('[data-fea-bar-fill]').forEach((el) => {
      if (el instanceof HTMLElement) el.style.width = '';
    });
    this.querySelectorAll('[data-fea-bar]').forEach((el) => {
      delete el.dataset.feaHighlight;
    });
    this.querySelectorAll('[data-fea-colors], [data-fea-crystals], [data-fea-product-grid]').forEach((el) => {
      el.replaceChildren();
    });
    const grid = this.querySelector('[data-fea-product-grid]');
    if (grid instanceof HTMLElement) grid.hidden = true;
    const results = this.querySelector('[data-fea-view="results"]');
    if (results instanceof HTMLElement) delete results.dataset.accent;
    this.#setUnlockStatus('');
  }

  #onReset = () => {
    this.#clearPrivateState();
    this.#setView('intro');
    this.#setError('');
    this.#setLoading(false);
    this.querySelector('[data-fea-view="intro"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  #setUnlockStatus(message, state) {
    const el = this.querySelector('[data-fea-unlock-status]');
    if (!(el instanceof HTMLElement)) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      delete el.dataset.state;
      return;
    }
    el.hidden = false;
    el.textContent = message;
    el.dataset.state = state || 'info';
  }

  #onUnlockClick = (event) => {
    event.preventDefault();
    const form = this.querySelector('[data-fea-unlock-form]');
    if (form instanceof HTMLFormElement) this.#handleUnlock(form);
  };

  #onUnlockSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form instanceof HTMLFormElement) this.#handleUnlock(form);
  };

  /**
   * @param {HTMLFormElement} form
   */
  #handleUnlock = (form) => {
    const copy = form.querySelector('[data-fea-unlock-copy]');
    const chinese = isChineseLocale(this.dataset.locale);
    const recipient = String(form.dataset.feaReportMailto || '').trim();
    if (recipient !== 'contact.sanctura@gmail.com') {
      this.#setUnlockStatus(chinese ? '邮件报告暂未开放。您仍可在本页查看测算结果。' : 'Email reports are not available yet. You can still view your results on this page.', 'info');
      return;
    }
    const result = this.#lastResult;
    if (!result) {
      this.#setUnlockStatus(chinese ? '请先完成本页测算。' : 'Please complete the assessment on this page first.', 'error');
      return;
    }
    const input = form.querySelector('[data-fea-unlock-email]');
    const email = input instanceof HTMLInputElement ? input.value.trim() : '';
    if (!(input instanceof HTMLInputElement) || !input.checkValidity() || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      const invalidText = copy instanceof HTMLElement ? copy.dataset.invalidText : '';
      this.#setUnlockStatus(invalidText || (chinese ? '请输入有效的回复邮箱。' : 'Please enter a valid reply email address.'), 'error');
      input?.focus();
      return;
    }
    const consent = form.querySelector('[data-fea-report-consent]');
    if (!(consent instanceof HTMLInputElement) || !consent.checked) {
      const consentText = copy instanceof HTMLElement ? copy.dataset.consentText : '';
      this.#setUnlockStatus(consentText || (chinese ? '请单独同意将邮箱与测算结果摘要用于客服人工回复。' : 'Please consent to using your email and result summary for a manual customer service reply.'), 'error');
      return;
    }

    const ziweiSummary = result.ziwei.startsWith('Zi Wei unavailable:') || result.ziwei.startsWith('紫微计算失败：')
      ? (chinese ? '紫微计算暂不可用。' : 'Zi Wei calculation unavailable')
      : result.ziwei;
    const summary = [
      'Five Elements report request',
      'Reply email: ' + email,
      '',
      'Four Pillars: ' + result.bazi,
      'Destiny Palace Stars: ' + ziweiSummary,
      'Weakest element: ' + result.weakest,
      'Element in excess: ' + result.unfavorable,
      'Beneficial colors: ' + result.colors.map((color) => color.name).join(', '),
      'Supportive stones: ' + result.crystals.join(', '),
    ].join('\r\n');
    const mailto = 'mailto:' + recipient + '?subject=' + encodeURIComponent('Sanctura Five Elements report request') + '&body=' + encodeURIComponent(summary);
    const fallbackText = chinese
      ? '请在邮件程序检查并发送；如未打开，请发邮件至 ' + recipient + '。客服将人工回复。'
      : 'Please check and send in your email app. If it did not open, email ' + recipient + '. Customer service will reply manually.';
    try {
      window.location.href = mailto;
      const successText = copy instanceof HTMLElement ? copy.dataset.successText : '';
      this.#setUnlockStatus(successText || fallbackText, 'info');
    } catch {
      const errorText = copy instanceof HTMLElement ? copy.dataset.errorText : '';
      this.#setUnlockStatus(errorText || fallbackText, 'error');
    } finally {
      this.#clearInputs('[data-fea-unlock-email], [data-fea-report-consent]');
    }
  };

  #onSubmit = async (event) => {
    event.preventDefault();
    if (this.dataset.loading === 'true') return;
    this.#setError('');

    const form = event.currentTarget;
    if (!(form instanceof HTMLFormElement)) return;
    const chinese = isChineseLocale(this.dataset.locale);
    const requiresAgeConfirmation = !this.classList.contains('fea--reference');
    const ageConfirmation = form.querySelector('[data-fea-age-confirmation]');
    if (requiresAgeConfirmation && (!(ageConfirmation instanceof HTMLInputElement) || !ageConfirmation.checked)) {
      this.#setError(chinese ? '请确认您已年满18周岁。' : 'Please confirm that you are at least 18 years old.');
      return;
    }

    const dateInput = form.querySelector('[name="date_of_birth"]');
    const timeInput = form.querySelector('[name="time_of_birth"]');
    const dateVal = dateInput instanceof HTMLInputElement ? dateInput.value : '';
    const timeVal = timeInput instanceof HTMLInputElement ? timeInput.value : '';

    if (!dateVal || !timeVal) {
      this.#setError(chinese ? '请输入出生日期和时间。' : 'Please enter your date and time of birth.');
      return;
    }

    const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateVal);
    const year = Number(dateParts?.[1]);
    const month = Number(dateParts?.[2]);
    const day = Number(dateParts?.[3]);
    const birthDate = new Date(0);
    birthDate.setHours(0, 0, 0, 0);
    birthDate.setFullYear(year, month - 1, day);
    const today = new Date();
    if (!dateParts || year < 1 || birthDate.getFullYear() !== year || birthDate.getMonth() !== month - 1 || birthDate.getDate() !== day || birthDate > today) {
      this.#setError(chinese ? '请输入有效的出生日期。' : 'Please enter a valid date of birth.');
      return;
    }
    const birthdayPending = today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day);
    const age = today.getFullYear() - year - (birthdayPending ? 1 : 0);
    if (requiresAgeConfirmation && age < 18) {
      this.#setError(chinese ? '此测算仅供年满18周岁的用户使用。' : 'This assessment is only available to people aged 18 or over.');
      return;
    }

    const genderInput = form.querySelector('[name="gender"]:checked');
    const genderVal = genderInput instanceof HTMLInputElement && genderInput.type === 'radio' ? genderInput.value : '';
    if (genderVal !== 'male' && genderVal !== 'female') {
      this.#setError(chinese ? '请选择测算使用的性别。' : 'Please select a gender for the assessment.');
      return;
    }
    const assessmentId = ++this.#assessmentId;
    this.#setLoading(true);

    try {
      await ensureEngines();
      if (assessmentId !== this.#assessmentId || !this.isConnected) return;
      const result = runAssessment({
        dateVal,
        timeVal,
        genderVal,
        locale: this.dataset.locale || 'en',
      });
      if (result.ziwei.startsWith('Zi Wei unavailable:') || result.ziwei.startsWith('紫微计算失败：')) {
        result.ziwei = chinese ? '紫微计算暂不可用。' : 'Zi Wei calculation unavailable';
      }
      this.#lastResult = result;
      this.#clearRawInputs();
      this.#setUnlockStatus('');
      this.#showResults(result);
    } catch (error) {
      if (assessmentId !== this.#assessmentId || !this.isConnected) return;
      console.error('Assessment failed');
      this.#clearRawInputs();
      this.#setError(chinese ? '测算暂时无法完成，请重试。' : 'Assessment could not be completed. Please try again.');
    } finally {
      if (assessmentId === this.#assessmentId) this.#setLoading(false);
    }
  };
}

if (!customElements.get('five-elements-analysis')) {
  customElements.define('five-elements-analysis', FiveElementsAnalysis);
}
